import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { SidebarProvider, useSidebar } from '../context/SidebarContext';

const LayoutContent = () => {
  const { isOpen } = useSidebar();

  return (
    <Box sx={{ display: 'flex', className: 'app-body' }}>
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          marginLeft: isOpen ? '270px' : '60px',
          transition: 'margin-left 0.3s ease',
          backgroundColor: '#f1f5f9',
          minHeight: '100vh',
          pt: '64px',
        }}
      >
        <Header />
        <Box sx={{ height: '1px', backgroundColor: '#e0e0e0', width: '100%' }} />
        <Box sx={{ p: 3 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

const Layout = () => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default Layout;